import { createContext } from 'react';
import tracker from './tracker';

export const AppContext = createContext();

export const withLocalStorageCache = reducer => { return (state, action) => {
  const newState = reducer(state, action);
  const _newState = {...newState, message: null };
  localStorage.setItem("hm-state", JSON.stringify(_newState));
  return newState;
}};

const initialState = {
  message: null,
  user: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    isAuthenticated: false,
    isReauthenticating: false,
    language: 'en-US',
    isLoading: false,
    signedUp: false,
    sites: [],
    siteId: null,
    plan: null,
    logins: 0,
    primaryDomain: "",
    jwt: null
  },
  groups: []
};

export const getInitialState = () => {
  try {
    const state = JSON.parse(localStorage.getItem("hm-state"));
    return state || initialState;
  } catch (err) {
    return initialState;
  }
};

export const appReducer = (state, action) => {
  switch (action.type) {
    case 'SET_MESSAGE':
      return { ...state, message: action.message };

    // AUTH
    case 'USER_LOADING':
      return {...state, user: { ...state.user,
        isLoading: true
      }};

    case 'USER_LOGIN_SUCCEEDED':
      const { signedUp, id, firstName, lastName, email, sites, siteId, plan, logins, primaryDomain, jwt } = action.payload;
      const data = {...state, user: {...state.user,
        isLoading: false,
        isAuthenticated: true,
        id, firstName, lastName, email, sites, siteId, plan, logins, primaryDomain, jwt},
        groups: []
      };

      tracker.track(signedUp ? 'Signed Up' : 'Signed In', data);
      tracker.identify(state.user.id, data);

      return data;

    case 'USER_LOGIN_FAILED':
      return {...state, user: {...state.user,
        isLoading: false,
      }};

    case 'USER_LOGOUT':
      return { ...initialState };

    case 'UPDATE_CURRENT_SITE':
      let _site = { ...action.payload };
      delete _site.availableTimezones;
      return { ...state, user: { ...state.user, currentSite: _site }};

    case 'SET_CURRENT_SITE':
      return { ...state, user: { ...state.user, siteId: action.payload }};

    case 'ADD_SITE':
      return { ...state, user: { ...state.user, sites: [...state.user.sites, action.payload], siteId: action.payload.id }}; 

    case 'SET_GROUPS':
      return { ...state, groups: action.payload };
    
    case 'ADD_GROUP':
      return { ...state, groups: [...state.groups, action.payload] };

    case 'HIGHLIGHT_ADDING_CONTACTS_TO_GROUPS':
      return { ...state, highlightAddingContactsToGroups: action.payload };

    default:
      throw new Error('Unexpected action');
  }
};
